import {getHttp, getUrlParams, lazySingleton, parseJwt} from "../_common/common";
import {CompanyLoginPostRequest, CompanyUser} from "../_api";
import companyApi, {authSvc} from "./jobs";
import {toastService} from "./toast-service";

export default class AuthService{

    // singleton de auth service
    static instance = lazySingleton(()=>new AuthService());
    micuentaenv : any;

    constructor() {
        this.micuentaenv = (<any>window).micuentaenv;
    }

    async isLoggedIn(){
        try{
            return await companyApi().companyUserGet();
        }
        catch(error){
            return null;
        }
    }

    async authenticate(login: any) {

        try {

            await authSvc().companyLoginPost({companyLogin: login}); // pasa o peta
            const userData = await companyApi().companyUserGet();
            if(!userData) return null;

            return userData;
        }
        catch(err){
            // if(err.status == 404) throw new Error('No se encuentra el usuario o la empresa no se ha validado todavía');
            err = await err.json();
            toastService.showToast({message: err.msg, type: 'danger'})
            // throw new Error('Fallo de autenticación: ' + err.msg);
        }
    }

    async recoverPassword(email:string){
        try{
            return await authSvc().companyLostPasswordPost({email});
        }
        catch(error){
            return null;
        }
    }

    async resetPassword(token:string, newPassword:string){
        try{
            return await authSvc().companyResetPasswordTokenPost({token, newPassword});
        }
        catch(error){
            return null;
        }
    }

    async loginService(svcUrl:string){
        let url = svcUrl + '/login?service=IlernaOnlineMyAccount';

        // tomamos los parametros
        const params = getUrlParams(location.href);

        if (params.ticket) {
            // quitamos los parametros de la url
            history.pushState(null, "", location.pathname);
            url += '&ticket=' + params.ticket;
        }

        const response = await getHttp(url);

        if(response.redirect) {
            setTimeout(() => location.href = response.redirect, 0);
            return false;
        }

        if (response.token) {
            return parseJwt(response.token);
        }

        return false;
    }

    async signout() {
        await authSvc().companyLogoutPost();
        setTimeout(()=>location.href = '/', 0);
    }

}
